module.exports = __webpack_public_path__ + "media/images/application/template/icon--link-internal-35d79587ee5140dd429652b3e0ac479a.svg";